import React, { useCallback, useEffect, useMemo } from 'react';

import { ICON_TYPES, ICONS } from '@/src/components/common/Elements/Icon/Icon';
import useConfirmPopup from '@/src/components/common/Elements/Modal/useConfirmPopup';
import SectionLoader from '@/src/components/common/Elements/Spinner/SectionLoader/SectionLoader';
import TreatmentDisplay from '@/src/components/project/Inbox2/components/EntryPanel/FileEntryViewer/components/InfoPanel/Treatment/components/TreatmentDisplay/TreatmentDisplay';
import { useTreatments } from '@/src/components/project/Inbox2/components/EntryPanel/FileEntryViewer/components/InfoPanel/Treatment/store/treatments.store';
import { FileEntry } from '@/src/components/project/Inbox2/types';
import { showToast } from '@/src/globalFunction';
import { queryClient } from '@/src/lib/react-query/react-query';

import TreatmentList from './TreatmentList/TreatmentList';

export type FullScreenSetting = {
  isContainerFullScreen: boolean;
  isViewerFullScreen: boolean;
};

type TreatmentProps = {
  fileEntry: FileEntry;
};

const Treatment = ({ fileEntry }: TreatmentProps) => {
  const { form, treatment, onReset } = useTreatments();

  return (
    <>
      {!form && !treatment && <TreatmentList fileEntry={fileEntry} />}
      {treatment && (
        <TreatmentDisplay treatment={treatment} onBack={onReset} isViewInQuickbooksEnabled={true} />
      )}
    </>
  );
};

export default Treatment;
